import { apiClient } from './client'
import type { ISODateTime, UUID } from './types'

/**
 * STEP 10.4 — ingestion jobs read API. The backend creates a job row for
 * every /ingest call so the frontend (and future background workers) can
 * surface status without inventing a parallel state store.
 */

export interface IngestionJobDTO {
  id: UUID
  tenant_id: string | null
  organization_id: UUID | null
  user_id: UUID | null
  document_id: UUID | null
  document_external_id: string | null
  document_kind: string | null
  filename: string | null
  status: 'queued' | 'processing' | 'indexed' | 'failed' | 'cancelled'
  error_message: string | null
  metadata_json: Record<string, unknown> | null
  started_at: ISODateTime | null
  finished_at: ISODateTime | null
  created_at: ISODateTime
  updated_at: ISODateTime
}

export interface IngestionJobsListResponseDTO {
  tenant_id: string
  total: number
  items: IngestionJobDTO[]
}

export interface ListIngestionJobsParams {
  tenantId: string
  status?: IngestionJobDTO['status']
  limit?: number
  offset?: number
}

export const ingestionApi = {
  listJobs: (params: ListIngestionJobsParams, signal?: AbortSignal) =>
    apiClient.get<IngestionJobsListResponseDTO>(
      '/api/v1/ingestion/jobs',
      {
        tenant_id: params.tenantId,
        status: params.status,
        limit: params.limit,
        offset: params.offset,
      },
      signal,
    ),

  getJob: (
    jobId: UUID,
    tenantId: string,
    signal?: AbortSignal,
  ) =>
    apiClient.get<IngestionJobDTO>(
      `/api/v1/ingestion/jobs/${jobId}`,
      { tenant_id: tenantId },
      signal,
    ),
}
